import React from "react";
import { makeStyles, Box, Container } from "@material-ui/core";
import Page from "../components/Page";
import FooterView from "../views/auth/FooterView";
import ResetPasswordContainer from "../containers/auth/ResetPasswordContainer";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.default,
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(15),
    [theme.breakpoints.down("xs")]: {
      paddingTop: theme.spacing(1),
    },
  },
}));

const renderFooterView = (type) => {
  switch (type) {
    case "installer":
      return <FooterView type={type} register={true} login={true} />;
    case "customer":
      return <FooterView type={type} register={true} login={true} />;
    case "admin":
      return <FooterView type={type} login={true} />;
    default:
      return <FooterView register={true} login={true} />;
  }
};

const ResetPage = () => {
  const classes = useStyles();
  let { type } = useParams();
  const { t } = useTranslation();

  return (
    <Page className={classes.root} title="Ecat">
      <Box
        display="flex"
        flexDirection="column"
        height="100%"
        justifyContent="center"
      >
        <Container maxWidth="sm">
          <ResetPasswordContainer message={t("reset.message")} />
          {renderFooterView(type)}
        </Container>
      </Box>
    </Page>
  );
};

export default ResetPage;
